import type { DropDownProps } from './dropdown.interface';

import classNames from 'classnames';
import { memo, useState } from 'react';

export const Dropdown = memo(({ label, children }: DropDownProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDropdown = () => setIsExpanded((prev) => !prev);

  return (
    <div className="dropdown">
      <div className="dropdown-toggle" onClick={toggleDropdown}>
        <p className="dropdown-toggle__name">
          <i
            className={classNames(
              'dropdown-toggle__icon',
              isExpanded && 'is-active',
            )}
          />
          {label}
        </p>
      </div>
      <div
        className={classNames('dropdown-content', isExpanded && 'is-expanded')}
      >
        {children}
      </div>
    </div>
  );
});

Dropdown.displayName = 'Dropdown';
